import * as React from "react";
import { TextInput } from "react-admin";

const EditClient = () => {
  return (
    <>
      <TextInput
        inputProps={{ maxLength: 64 }}
        source="city"
        sx={{
          width: "20%",
          "@media (max-width:900px)": {
            width: "100%",
          },
        }}
      />
      <TextInput
        inputProps={{ maxLength: 64 }}
        source="address"
        sx={{
          width: "20%",
          "@media (max-width:900px)": {
            width: "100%",
          },
        }}
      />
    </>
  );
};

export default EditClient;
